import styled from '@emotion/styled'
import { wrap as withStyle, themeColor } from 'utils/styles'
import Modal from 'components/patterns/Modal'
import Icon from 'components/patterns/Icon'

export const StyledModalContent = styled.div`
  display: flex;
`

export const StyledCustomSwitchGraphicsModal = styled(Modal)`
  &&& {
    .ant-modal-body {
      padding: 0px;
      height: 500px;
      overflow: auto;
    }

    .ant-modal-header {
      border-bottom: 1px solid ${themeColor('modalBorderColor')};
      & h1 {
        font-weight: bold;
        margin: 0;
      }
    }

    .ant-modal-title {
      display: block;
    }

    .ant-modal-footer {
      display: flex;
      justify-content: flex-end;
      border-top: 1px solid ${themeColor('modalBorderColor')};
    }
  }
`

export default withStyle(
  () => `
    .ant-modal-body {
      padding: 0px !important;
    }
  `
)

export const SVGContentDiv = styled.div`
  border-left: 1px solid ${themeColor('modalBorderColor')};
  width: 78%;
  margin-left: 8px;
  min-height: 500px;
  background-color: ${themeColor('modalGrey')};
`

export const SearchInputDiv = styled.div`
  width: 22%;
  height: 100%;
  padding-top: 20px;
  padding-left: 20px;
`
export const StyledSearchBox = styled.div`
  max-width: 315px;
  margin-bottom: 16px;
  p {
    margin-bottom: 6px;
  }
`

export const HeaderContainer = styled.div`
  align-items: start;
  display: flex;
  flex-direction: row;
`

export const CancelIcon = styled(Icon)`
  cursor: pointer;
  margin-left: auto;
  align-self: center;
  &&& {
    height: 18px;
    width: 20px;
  }
`
